import React, { useState } from 'react';
import { CheckCircle2, Timer, Users, AlertTriangle, Plus, X, Save } from 'lucide-react';

export default function Votaciones() {
  const [showNewVotacionModal, setShowNewVotacionModal] = useState(false);
  const [formData, setFormData] = useState({
    titulo: '',
    descripcion: '',
    fechaFin: '',
    opciones: ['', '']
  });

  const votaciones = [
    {
      id: 1,
      titulo: 'Presupuesto Anual 2024',
      descripcion: 'Votación para aprobar el presupuesto del año 2024',
      fechaInicio: '2024-03-01',
      fechaFin: '2024-03-15',
      estado: 'activa',
      participacion: 65,
      opciones: [
        { nombre: 'Aprobar', votos: 78 },
        { nombre: 'Rechazar', votos: 12 },
        { nombre: 'Abstención', votos: 10 },
      ],
    },
    {
      id: 2,
      titulo: 'Elección de Nueva Directiva',
      descripcion: 'Selección de los nuevos miembros del consejo directivo',
      fechaInicio: '2024-03-10',
      fechaFin: '2024-03-25',
      estado: 'activa',
      participacion: 45,
      opciones: [
        { nombre: 'Lista A', votos: 45 },
        { nombre: 'Lista B', votos: 35 },
        { nombre: 'Lista C', votos: 20 },
      ],
    },
    {
      id: 3,
      titulo: 'Modificación de Estatutos',
      descripcion: 'Votación finalizada sobre cambios en los estatutos de la cooperativa',
      fechaInicio: '2024-02-01',
      fechaFin: '2024-02-15',
      estado: 'finalizada',
      participacion: 89,
      opciones: [
        { nombre: 'Aprobar', votos: 120 },
        { nombre: 'Rechazar', votos: 15 },
        { nombre: 'Abstención', votos: 5 },
      ],
    },
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleOpcionChange = (index, value) => {
    const newOpciones = [...formData.opciones];
    newOpciones[index] = value;
    setFormData(prev => ({
      ...prev,
      opciones: newOpciones
    }));
  };

  const addOpcion = () => {
    setFormData(prev => ({
      ...prev,
      opciones: [...prev.opciones, '']
    }));
  };

  const removeOpcion = (index) => {
    if (formData.opciones.length > 2) {
      const newOpciones = formData.opciones.filter((_, i) => i !== index);
      setFormData(prev => ({
        ...prev,
        opciones: newOpciones
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Nueva votación:', formData);
    setShowNewVotacionModal(false);
    setFormData({
      titulo: '',
      descripcion: '',
      fechaFin: '',
      opciones: ['', '']
    });
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Votaciones</h1>
        <button 
          onClick={() => setShowNewVotacionModal(true)}
          className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 flex items-center gap-2"
        >
          <Plus className="w-5 h-5" />
          Nueva Votación
        </button>
      </div>

      <div className="grid gap-6">
        {votaciones.map((votacion) => (
          <div key={votacion.id} className="bg-white rounded-lg shadow p-6">
            <div className="flex items-start justify-between mb-4">
              <div>
                <h2 className="text-xl font-semibold text-gray-900">{votacion.titulo}</h2>
                <p className="text-gray-600 mt-1">{votacion.descripcion}</p>
              </div>
              <div className={`px-3 py-1 rounded-full text-sm font-medium ${
                votacion.estado === 'activa' 
                  ? 'bg-green-100 text-green-800'
                  : 'bg-gray-100 text-gray-800'
              }`}>
                {votacion.estado === 'activa' ? 'En Curso' : 'Finalizada'}
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
              <div className="flex items-center space-x-2 text-gray-600">
                <Timer className="w-5 h-5" />
                <span>
                  {votacion.fechaInicio} - {votacion.fechaFin}
                </span>
              </div>
              <div className="flex items-center space-x-2 text-gray-600">
                <Users className="w-5 h-5" />
                <span>Participación: {votacion.participacion}%</span>
              </div>
            </div>

            <div className="space-y-4">
              {votacion.opciones.map((opcion, index) => (
                <div key={index} className="relative">
                  <div className="flex justify-between mb-1">
                    <span className="text-gray-700">{opcion.nombre}</span>
                    <span className="text-gray-600">{opcion.votos} votos</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2.5">
                    <div
                      className="bg-green-600 h-2.5 rounded-full"
                      style={{
                        width: `${(opcion.votos / votacion.opciones.reduce((acc, curr) => acc + curr.votos, 0)) * 100}%`
                      }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>

            {votacion.estado === 'activa' && (
              <div className="mt-6 flex justify-end">
                <button className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700">
                  Emitir Voto
                </button>
              </div>
            )}
          </div>
        ))}
      </div>

      {showNewVotacionModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold text-gray-900">Crear Nueva Votación</h2>
              <button
                onClick={() => setShowNewVotacionModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Título de la Votación
                </label>
                <input
                  type="text"
                  name="titulo"
                  value={formData.titulo}
                  onChange={handleInputChange}
                  required
                  placeholder="Ej: Aprobación del presupuesto 2024"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Descripción
                </label>
                <textarea
                  name="descripcion"
                  value={formData.descripcion}
                  onChange={handleInputChange}
                  required
                  rows={3}
                  placeholder="Describe el tema a votar y proporciona contexto necesario"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Fecha de Cierre
                </label>
                <input
                  type="date"
                  name="fechaFin"
                  value={formData.fechaFin}
                  onChange={handleInputChange}
                  required
                  min={new Date().toISOString().split('T')[0]}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Opciones de Votación
                </label>
                <div className="space-y-3">
                  {formData.opciones.map((opcion, index) => (
                    <div key={index} className="flex gap-2">
                      <input
                        type="text"
                        value={opcion}
                        onChange={(e) => handleOpcionChange(index, e.target.value)}
                        required
                        placeholder={`Opción ${index + 1}`}
                        className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                      />
                      {formData.opciones.length > 2 && (
                        <button
                          type="button"
                          onClick={() => removeOpcion(index)}
                          className="px-3 py-2 text-red-600 hover:bg-red-50 rounded-lg"
                        >
                          <X className="w-4 h-4" />
                        </button>
                      )}
                    </div>
                  ))}
                  <button
                    type="button"
                    onClick={addOpcion}
                    className="flex items-center gap-2 text-green-600 hover:bg-green-50 px-3 py-2 rounded-lg"
                  >
                    <Plus className="w-4 h-4" />
                    Agregar Opción
                  </button>
                </div>
              </div>

              <div className="flex justify-end gap-4 pt-6">
                <button
                  type="button"
                  onClick={() => setShowNewVotacionModal(false)}
                  className="px-4 py-2 text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 flex items-center gap-2"
                >
                  <Save className="w-4 h-4" />
                  Crear Votación
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
